import React, { useState } from 'react';
import Swal from 'sweetalert2';

function AdminLogin({ onLogin }) {
  const [password, setPassword] = useState('');

  const handleLogin = async () => {
    if (password === 'Vendas.rolenzao2022') {
      onLogin(true);
    } else {
      await Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Senha incorreta!',
        confirmButtonColor: '#f44336'
      });
    }
  };

  return (
    <div>
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="SENHA DO ADM"
      />
      <button onClick={handleLogin}>Entrar</button>
    </div>
  );
}

export default AdminLogin;

